/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import AppLayout from '@/layouts/AppLayout';
import DashboardLayout from '@/layouts/DashboardLayout';
import MonitorLayout from '@/layouts/MonitorLayout';
import Dashboard from '@/pages/dashboard/Dashboard';
import ErrorPage from '@/pages/Error/ErrorPage';
import Landing from '@/pages/Landing';
import LoginPage from '@/pages/LoginPage';
import ViewReportPage from '@/pages/ViewReportPage/ViewReportPage';
import React from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import TooManyRequests from './pages/Error/TooManyRequests';

const ProjectRouter = () => {
    return (
        <React.Suspense fallback={<div>Loading...</div>}>
            <Router>
                <Routes>
                    <Route path="/" element={<AppLayout />}>
                        <Route index element={<Landing />} />
                        <Route path="monitor/:flowId" element={<MonitorLayout />} />
                        <Route path="viewReport/flow/:flowId/run/:runId" element={<ViewReportPage />} />
                        <Route path="dashboard" element={<DashboardLayout />}>
                            <Route index element={<Dashboard />} />
                            <Route path="flow/:flowId/phase/:phaseId/step/:stepId" element={<Dashboard />} />
                        </Route>
                        <Route path="error" element={<ErrorPage />} />
                        <Route path="login" element={<LoginPage />} />
                        <Route path="error-too-many-requests" element={<TooManyRequests />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </Router>
        </React.Suspense>
    );
};

export default ProjectRouter;
